<template>
  <cxl-vbden-common
    :isOpen="isOpen"
    :quote="quote"
    :note="note"
    :flowId="flowId"
    :selectedHandlers="selectedHandlers"
    :defaultProcessType="PROCESS_TYPE.CHUTRI"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
    ref="cxlDialog"
  />
</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import displayDepartmentTreeMixin from "../../../mixins/displayDepartmentTreeMixin";
  import CxlVbdenCommon from "./cxl-vbden-common";
  import constants from "../../../constants";

  export default {
    name: "cxl-vbden-vanthu-dialog",
    mixins: [handleRequestErrorMixin, displayDepartmentTreeMixin],
    filters: {buildShortNameFilter},
    props: [
      "flowId",
      "isOpen",
      "quote",
      "nextVbIncomingProcess",
      "selectedHandlers",
      "note"
    ],
    components: {
      CxlVbdenCommon,
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
      VuePerfectScrollbar
    },

    computed: {
      parentRoute() {
        return this.$route.path.split("/")[3];
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    data() {
      return {
        PROCESS_TYPE: constants.PROCESS_TYPE
      };
    },

    mounted() {
      this.$refs.cxlDialog.initForm();
    },

    methods: {
      submit(event) {
        this.$emit("submit", {
          handlersData: event.handlersData,
          note: event.note
        });
      }
    }
  };
</script>
<style scoped>
  /*.title {*/
  /*  width: 100%;*/
  /*}*/

  /*.list-checkbox {*/
  /*  position: relative;*/
  /*  margin-right: 25px;*/
  /*}*/

  /*.scroll-list-user {*/
  /*  height: auto;*/
  /*  width: 100%;*/
  /*  max-width: 100%;*/
  /*  max-height: 100%;*/
  /*  margin: auto;*/
  /*  padding-right: 3px;*/
  /*}*/

  .list-checkbox .item {
    width: 100px;
    text-align: center;
    margin: 0;
  }

  /*.icon-close {*/
  /*  position: absolute;*/
  /*  right: -5px;*/
  /*  font-size: 18px;*/
  /*}*/

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 70%;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: calc(100% - 15px);
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/clx-vbden-vanthu-dialog.vue